import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { company } from "@/data/content";

export const StickyMobileBar = () => (
  <div
    data-testid="sticky-mobile-bar"
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-3 border-t border-border bg-background/95 px-4 py-3 backdrop-blur-sm md:hidden"
    style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
  >
    <a
      href={company.phoneHref}
      data-testid="sticky-call"
      className="flex h-12 items-center justify-center gap-2 rounded-md border border-foreground/20 text-sm font-semibold text-foreground transition-colors active:bg-foreground/5"
    >
      <Phone className="h-4 w-4" /> Zavolat
    </a>
    <Link
      to="/#kontakt"
      data-testid="sticky-inquiry"
      className="flex h-12 items-center justify-center gap-2 rounded-md bg-primary text-sm font-semibold text-primary-foreground transition-colors active:bg-primary/90"
    >
      <FileText className="h-4 w-4" /> Poptávka
    </Link>
  </div>
);
